var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5V1C22 0.45 21.55 0 21 0H17C16.45 0 16 0.45 16 1V2H6V1C6 0.45 5.55 0 5 0H1C0.45 0 0 0.45 0 1V5C0 5.55 0.45 6 1 6H2V16H1C0.45 16 0 16.45 0 17V21C0 21.55 0.45 22 1 22H5C5.55 22 6 21.55 6 21V20H16V21C16 21.55 16.45 22 17 22H21C21.55 22 22 21.55 22 21V17C22 16.45 21.55 16 21 16H20V6H21C21.55 6 22 5.55 22 5ZM2 2H4V4H2V2ZM4 20H2V18H4V20ZM16 18H6V17C6 16.45 5.55 16 5 16H4V6H5C5.55 6 6 5.55 6 5V4H16V5C16 5.55 16.45 6 17 6H18V16H17C16.45 16 16 16.45 16 17V18ZM20 20H18V18H20V20ZM18 4V2H20V4H18ZM11.94 6.65C11.79 6.26 11.41 6 10.99 6C10.57 6 10.19 6.26 10.05 6.65L7.28 13.98C7.09 14.47 7.45 15 7.98 15C8.3 15 8.58 14.8 8.69 14.5L9.24 13H12.73L13.29 14.51C13.4 14.8 13.68 15 14 15H14.01C14.54 15 14.9 14.47 14.72 13.98L11.94 6.65ZM9.69 11.74L11 7.91L12.3 11.74H9.69Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.836a2bec.svg";
export { ForwardRef as ReactComponent };